import  { useState } from 'react'
import {  FaPlus } from 'react-icons/fa'
import useCurrentTeacher from '../../../../hooks/useCurrentTeacher'
import { Trash2,Pencil } from 'lucide-react'
const LEVELS = ["Beginner", "Intermediate", "Expert", "Advanced", "Master"]

const Skills = () => {
  const { teacher, fetchCurrentTeacher } = useCurrentTeacher()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentSkill, setCurrentSkill] = useState({ skill: '', level: '' })
  const [originalSkill, setOriginalSkill] = useState('') // track original skill name

  if (!teacher) return null

  const handleEdit = (skill) => {
    setCurrentSkill(skill)
    setOriginalSkill(skill.skill)
    setIsModalOpen(true)
  }

  const handleAdd = () => {
    setCurrentSkill({ skill: '', level: '' })
    setOriginalSkill('')
    setIsModalOpen(true)
  }

  const handleDelete = async (skillName) => {
    if (!window.confirm(`Are you sure you want to delete ${skillName}?`)) return

    try {
      const updatedSkills = teacher.skills.filter(s => s.skill !== skillName)
      const formData = new FormData()
      formData.append('skills', JSON.stringify(updatedSkills))

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      })

      if (res.ok) {
        alert('Skill deleted successfully!')
        fetchCurrentTeacher()
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to delete skill')
      }
    } catch (err) {
      console.error(err)
      alert('Error deleting skill')
    }
  }

  const handleSave = async () => {
    if (!currentSkill.skill.trim() || !currentSkill.level.trim()) {
      alert('Please enter skill and select a level')
      return
    }

    try {
      let updatedSkills
      if (originalSkill && teacher.skills.some(s => s.skill === originalSkill)) {
        updatedSkills = teacher.skills.map(s =>
          s.skill === originalSkill ? currentSkill : s
        )
      } else {
        updatedSkills = [...teacher.skills, currentSkill]
      }

      const formData = new FormData()
      formData.append('skills', JSON.stringify(updatedSkills))

      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/teacher/${teacher.id}/`, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: formData,
      })

      if (res.ok) {
        alert('Skill saved successfully!')
        fetchCurrentTeacher()
        setIsModalOpen(false)
      } else {
        const data = await res.json()
        alert(data.msg || 'Failed to save skill')
      }
    } catch (err) {
      console.error(err)
      alert('Error saving skill')
    }
  }

  return (
 <div className="p-2 md:p-6 bg-white rounded-2xl">
  {/* Header */}
  <div className="flex items-center justify-between mb-6">
    <div className="flex items-center gap-3">
      <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
        <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <div>
        <h2 className="text-lg font-semibold text-gray-900">Your Skills</h2>
        <p className="text-sm text-gray-500 mt-0.5">Manage your professional skills</p>
      </div>
    </div>
    <button
      className="w-10 h-10 bg-[#0f6abf] text-white rounded-full flex items-center justify-center hover:bg-[#0a5ca8] transition-colors"
      onClick={handleAdd}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
    </button>
  </div>

  {/* Skills Table */}
  {teacher.skills && teacher.skills.length > 0 ? (
    <div className="border border-gray-200 rounded-xl overflow-hidden">
      <div className="grid grid-cols-3 bg-gray-50 p-4 border-b border-gray-200">
        <div className="text-sm font-semibold text-gray-700">Skill</div>
        <div className="text-sm font-semibold text-gray-700">Level</div>
        <div className="text-sm font-semibold text-gray-700 text-right">Actions</div>
      </div>
      <div className="divide-y divide-gray-200">
        {teacher.skills.map((s, index) => (
          <div key={index} className="grid grid-cols-3 items-center p-4 hover:bg-gray-50 transition-colors">
            <div className="font-medium text-gray-900">{s.skill}</div>
            <div>
              <span className="px-3 py-1.5 text-xs font-medium bg-gray-100 text-gray-700 rounded-lg">
                {s.level}
              </span>
            </div>
            <div className="flex justify-end gap-2">
              <button
                className="w-9 h-9 bg-gray-100 text-gray-700 rounded-xl flex items-center justify-center hover:bg-gray-200 transition-colors"
                onClick={() => handleEdit(s)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
              </button>
              <button
                className="w-9 h-9 bg-red-100 text-red-600 rounded-xl flex items-center justify-center hover:bg-red-200 transition-colors"
                onClick={() => handleDelete(s.skill)}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-700 mb-2">No skills added yet</h3>
      <p className="text-sm text-gray-500 mb-4">Add your professional skills to showcase expertise</p>
      <button
        className="px-4 py-2 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
        onClick={handleAdd}
      >
        Add Your First Skill
      </button>
    </div>
  )}

  {/* Modal */}
  {isModalOpen && (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl">
        {/* Modal Header */}
        <div className="p-2 md:p-6 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {originalSkill ? 'Edit Skill' : 'Add Skill'}
              </h3>
              <p className="text-sm text-gray-500 mt-0.5">
                {originalSkill ? 'Update your skill details' : 'Add a new skill'}
              </p>
            </div>
          </div>
        </div>

        {/* Modal Content */}
        <div className="p-2 md:p-6">
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">Skill Name</label>
            <input
              type="text"
              placeholder="Enter skill name"
              value={currentSkill.skill}
              onChange={(e) =>
                setCurrentSkill({ ...currentSkill, skill: e.target.value })
              }
              className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
            />
          </div>

          {/* Level Tabs */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-3">Proficiency Level</label>
            <div className="flex flex-wrap gap-2">
              {LEVELS.map((level) => (
                <button
                  key={level}
                  type="button"
                  onClick={() => setCurrentSkill({ ...currentSkill, level })}
                  className={`px-4 py-2.5 text-sm font-medium rounded-xl transition-all ${
                    currentSkill.level === level
                      ? 'bg-[#0f6abf] text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {level}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
          <div className="flex items-center justify-end gap-3">
            <button
              onClick={() => setIsModalOpen(false)}
              className="px-4 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSave}
              className="px-4 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors"
            >
              {originalSkill ? 'Update Skill' : 'Add Skill'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )}
</div>

  )
}

export default Skills
